import React from "react";

import EMPTY_LIST_COURSE from "assets/images/empty-list-cactus-transparent.png";
import EMPTY_LIST_CLASS from "assets/images/empty-list-seagull-transparent.png";

const GenericImage = (props) => {
  return (
    <img
      alt={props.alt || "generic container"}
      src={props.imagePath}
      style={{
        objectFit: "contain",
        maxWidth: "100%",
        maxHeight: "100%",
        borderRadius: "2%",
      }}
    />
  );
};

export const NoClasses = () => {
  return <GenericImage imagePath={EMPTY_LIST_CLASS} alt="No classes" />;
};

export const NoCourses = () => {
  return <GenericImage imagePath={EMPTY_LIST_COURSE} alt="No courses" />;
};

export default GenericImage;
